import deviceInfo from "./deviceInfo";
import tohash from "./tohash";

export default function buildUserObj(profile: { name?: string; email: string; picture?: string, login_type: string, password?: string }) {
    const { name = '', email, picture = '', login_type, password = '' } = profile;
    const device = deviceInfo();
    const deviceId = tohash(`${device.name}${device.platform}${device.os}${email}${device.version}`);
    return {
        user_name: name,
        user_email: email,
        user_image: picture,
        login_type: login_type,
        device_id: deviceId,
        device_name: device.name,
        app_ver: device.version,
        dev_make: device.os,
        dev_model: device.platform,
        user_password: password,
        a_id: 0,
        apple_socail_id: '',
        fcm_id: '',
        user_dob: '',
        user_cc: 'US',
        dev_cc: 'US',
        app_usage_counter: '5000',
        dev_lang: 'eng'
    };
};